import React, { FC } from 'react';
import classNames from 'classnames';
import { useLocation, useNavigate } from 'react-router-dom';

import Button from 'vibo-ui/Button';
import Icon, { IconmoonFont } from 'vibo-ui/Icon';

import { GoBackProps } from './interfaces';

import useStyles from './style';

const GoBack: FC<GoBackProps> = ({ className, to, options, onClick, children, ...rest }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const classes = useStyles();

  const handleClick = () => {
    const routeState = location.state as HistoryRouteState;

    if (!!to) {
      navigate(to, options);
    } else if (routeState?.prevPath) {
      navigate(routeState.prevPath);
      routeState.prevPath = null;
    } else {
      navigate(-1);
    }
  };

  return (
    <Button
      className={classNames('goBack', classes.goBack, className)}
      displayType="link"
      {...rest}
      onClick={onClick || handleClick}
    >
      {children || <Icon icon={IconmoonFont['arrowLeft-24']} />}
    </Button>
  );
};

export default GoBack;
